<template>
  <loader fill />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '@/components/Loader.vue';

export default {
  name: 'Latest',
  components: {
    Loader,
  },
  computed: {
    ...mapGetters(['getLatestStripNumber']),
  },
  methods: {
    ...mapActions(['fetchLatestStrip']),
  },
  created() {
    this.fetchLatestStrip().then(() => {
      this.$router.push({
        name: 'Comic',
        params: {
          stripNumber: this.getLatestStripNumber,
        },
      });
    });
  },
};
</script>
